import type { QueryClient } from '@tanstack/react-query'
import { AuthApi } from '@/lib/api/auth'
import { chefKeys } from '@/lib/api/query-keys'

function removeAccountData(client: QueryClient) {
  client.removeQueries({ predicate: query => query.queryKey[0] !== chefKeys.profile[0] || query.queryKey[1] !== chefKeys.profile[1] })
  client.getMutationCache().clear()
}

export function clearAnonymousAccountCache(client: QueryClient) {
  if (client.getQueryData(chefKeys.profile) === null) removeAccountData(client)
}

export async function clearSessionCache(client: QueryClient) {
  await client.cancelQueries()
  removeAccountData(client)
  // Keep the observed profile query alive so AuthProvider receives session changes.
  client.setQueryData(chefKeys.profile, null)
}

export async function loginSession(client: QueryClient, phoneNumber: string, code: string) {
  await AuthApi.loginWithOtp(phoneNumber, code)
  await clearSessionCache(client)
  const { data: user } = await AuthApi.profile()
  client.setQueryData(chefKeys.profile, user)
  return user
}

export async function logoutSession(client: QueryClient) {
  await AuthApi.logout()
  await clearSessionCache(client)
}
